module.exports = __webpack_public_path__ + "img/chr_ts_13_penlight.02216949.png";